import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { Link } from "react-router-dom";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";

const LunchSpecial = () => {
  const { t, i18n } = useTranslation();

  return (
    <LunchSpecialDiv>
      <Hero
        bgImage="promotions/dining/lunch-special-2025/lunch-special-hero-image-2400x800px.jpg "
        buttonSettings={null}
        image={`promotions/dining/lunch-special-2025/lunch-special-logo-${i18n.language}-2400x2400px.png`}
        description={t("diningPromos.lunchSpecial.hero.title")}
        descriptionBgColor="#0000004d"
      >
        {/* <p>For just $7</p> */}
      </Hero>
      <MainContentDiv>
        <container-div>
          <Row className="g-4 mb-5" xs={1} md={2}>
            <Col>
              <SubTitleSection
                as={"h2"}
                subTitle={t("diningPromos.lunchSpecial.content.subtitle")}
              />
              <ReactMarkdown className="desc">
                {t(
                  "diningPromos.lunchSpecial.content.lunch.description"
                )}
              </ReactMarkdown>
              <ReactMarkdown>
                {t(
                  "diningPromos.lunchSpecial.content.pgPlayersCard.description_elevate"
                )}
              </ReactMarkdown>
              <p>
                <strong>
                  {t(
                    "diningPromos.lunchSpecial.content.pgPlayersCard.description_no_card"
                  )}
                  &nbsp;
                  <Link to={t("routes.register")}>
                    {t(
                      "diningPromos.lunchSpecial.content.pgPlayersCard.description_sign_up"
                    )}
                  </Link>
                </strong>
              </p>
              <ReactMarkdown>
                {t(
                  "diningPromos.lunchSpecial.content.pgPlayersCard.description_2"
                )}
              </ReactMarkdown>
            </Col>
            <Col className="pt-md-4 position-relative">
              <ResponsiveImage
                className="position-absolute price-label"
                src={`promotions/dining/lunch-special-2025/lunch-special-Price-bubble-800x800px-${i18n.language}.png`}
                // src={`promotions/dining/lunch-special-2025/lunch-special-homepage-carousel-1368x1200px-en.jpg `}
                alt={t("diningPromos.lunchSpecial.hero.title")}
              />
              <ResponsiveImage
                // src={`promotions/dining/lunch-special-2025/lunch-special-Price-bubble-800x800px-${i18n.language}.png`}
                src={`promotions/dining/lunch-special-2025/lunch-special-homepage-carousel-1368x1200px-en.jpg `}
                alt={t("diningPromos.lunchSpecial.hero.title")}
              />
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
      <container-div>
        <center-content>
          <p className="small">
            {t("diningPromos.lunchSpecial.content.smallText")}
          </p>
        </center-content>
      </container-div>
    </LunchSpecialDiv>
  );
};

const LunchSpecialDiv = styled.div`
  width: 100%;
  height: auto;
  /* min-height: 100vh; */
  background: var(--lightblack);
  color: var(--white);
  padding-bottom: 1rem;
  .hero_image {
    padding: 2rem 2rem 4rem;
    @media (min-width: 768px) {
      padding: 3rem;
    }
    opacity: 0.9;
  }
  .small {
    text-align: center;
  }
`;

const MainContentDiv = styled.div`
  padding-bottom: 1rem;
  h2:after {
    border-color: #F44C00;
  }
  @media (min-width: 768px) {
    padding: 2rem 1rem 1rem;
  }
  container-div {
    background: rgba(0, 0, 0, 0.5);
  }
  /* @media (min-width: 992px) {
    padding: 3rem 0;
  } */
  height: auto;
  width: 100%;
  text-align: left;
  .p_1 strong {
    white-space: nowrap;
  }
  .desc strong {
    color: #F44C00;
  }
  p {
    margin-bottom: 2rem;
  }
  .price-label {
    position: absolute;
    width: 50%;
    height: 50%;
    top: 10%;
    right: 10%;
  }
`;

export default LunchSpecial;
